import { render, staticRenderFns } from "./application-view.vue?vue&type=template&id=ad89c972"
import script from "./application-view.vue?vue&type=script&lang=js"
export * from "./application-view.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports